import { t } from '@lingui/core/macro'

import type { RequestError } from './extractHttpError'

/**
 * ky's `HTTPError` message is a stack-trace-shaped string that embeds the
 * request URL, so it never goes in front of an agent. Show the reason the API
 * gave instead, and copy we wrote when it did not give one.
 */
export const getDisplayMessage = (
  error?: RequestError | null,
  fallback?: string,
): string => {
  // `cause` is optional-chained because React Query reports a throwing `select`
  // as the query error, keeping the type but not the `RequestError` shape.
  const displayMessage = error?.cause?.displayMessage

  if (typeof displayMessage === 'string') return displayMessage

  return (
    fallback ?? t`Please try again. If the issue persists, contact support.`
  )
}
